<script lang="ts">
	import { page } from '$app/stores';
	import Image from '$lib/components/Image.svelte';
	import { AspectRatio, LoadingPriority, type ArticleThumbnail } from '$lib/satellite.types';
	import { url } from '$lib/utils/ArticleHelper';
	import Byline from './_byline.svelte';

	export let article: ArticleThumbnail;
	export let lazy: boolean = false;

	const colors = $page.data.property.colors;
</script>

{#key article}
	<a href={url(article)} class="group block rounded-lg overflow-hidden">
		<div class="flex gap-6 group-hover:bg-gray-50 transition-colors duration-300">
			<div class="basis-4/12 aspect-[1/1] relative overflow-hidden rounded-lg">
				<!-- Hover Overlay -->
				<div
					class={`absolute z-20 w-full h-full inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-300 ${colors.background}`}
				></div>

				<Image
					alt={article.title}
					classList="w-full h-full object-cover rounded-lg group-hover:scale-105 transform transition-transform duration-300 group-hover:rotate-2"
					blurhash={article.imageFeaturedBlurHash}
					image={article.imageFeatured}
					aspectRatio={AspectRatio._1BY1}
					loading={lazy ? LoadingPriority.LAZY : LoadingPriority.EAGER}
					sizes="(max-width: 1023px) 33vw, (min-width: 1024px) 153px, (min-width: 1280px) 159px, 100vw"
				/>
			</div>

			<div class="basis-8/12 flex items-center">
				<div class="pr-3">
					<Byline {article}></Byline>
				</div>
			</div>
		</div>
	</a>
{/key}
